import axios from 'axios';

class PaymentRequestService {
  create (uuid) {
    return axios.post('backend://payment-request/' + uuid + '/swish')
      .then((response) => response.data.data);
  }
}

export default new PaymentRequestService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/payment-request/payment-request-service.js
 **/